module.exports = __webpack_public_path__ + "img/nightmare.b3cbcea6.png";